import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import { Collapse, Nav, NavItem, NavLink as BootstrapNavLink } from 'reactstrap';
import AppContext from '../../context/Context';
import NavbarVerticalMenuItem from './NavbarVerticalMenuItem';

const NavbarVerticalMenu = ({ routes, location }) => {

  const { selectedCondominium } = useSelector(state => state.condominium);
  const [openedIndex, setOpenedIndex] = useState(null);
  const { setShowBurgerMenu } = useContext(AppContext);

  useEffect(() => {

    let isMounted = true;
    let openedDropdown = null;
    routes.forEach((route, index) => {
      if (route.to && location.pathname.indexOf(route.to) === 0) openedDropdown = index;
    });

    // HO-HU-36: los grupos del menu (ej. "Administración") no tienen `to`, asi
    // que el match por URL de arriba nunca los abria y quedaban colapsados
    // siempre. Con `defaultOpen` el grupo arranca desplegado cuando la URL
    // actual no apunta a ninguna otra rama del menu.
    if (openedDropdown === null) {
      const defaultOpened = routes.findIndex(route => route.defaultOpen);
      if (defaultOpened !== -1) openedDropdown = defaultOpened;
    }

    isMounted&&setOpenedIndex(openedDropdown);
    return ()=>{ isMounted = false; }
    // eslint-disable-next-line
  }, []);

  const toggleOpened = (e, index) => {
    e.preventDefault();
    return setOpenedIndex(openedIndex === index ? null : index);
  };

  return routes.map((route, index) => {
    if (!!!route.children) {
      return  <NavItem key={index.toString()}>
                <NavLink className="nav-link" {...route} onClick={() => setShowBurgerMenu(false)}>
                  <NavbarVerticalMenuItem route={route} />
                </NavLink>
              </NavItem>
    }

    if (route.name === 'Administración' && !selectedCondominium) { return <Fragment key={index.toString()}></Fragment> }

    return  <NavItem key={index.toString()}>
              <BootstrapNavLink
                onClick={e => toggleOpened(e, index)}
                className="dropdown-indicator cursor-pointer"
                aria-expanded={openedIndex === index}
              >
                <NavbarVerticalMenuItem route={route} />
              </BootstrapNavLink>
              <Collapse isOpen={openedIndex === index}>
                <Nav>
                  <NavbarVerticalMenu routes={route.children} location={location} />
                </Nav>
              </Collapse>
            </NavItem>
  });
}

NavbarVerticalMenu.propTypes = {
  routes: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired
};

export default withRouter(NavbarVerticalMenu);